"use strict";
var rating_component_1 = require('./rating/rating.component');
exports.RatingComponent = rating_component_1.RatingComponent;
var rating_module_1 = require('./rating/rating.module');
exports.RatingModule = rating_module_1.RatingModule;



//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/~/ng2-bootstrap/components/rating.js
// module id = ../../../../ng2-bootstrap/components/rating.js
// module chunks = 3